import * as React from "react";

const SvgIcnLoading = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.877 8.596a.435.435 0 01-.317-.534C3.45 4.807 6.492 2.5 10.004 2.5c2.934 0 5.551 1.612 6.849 4.062l.28-2.847.014-.078a.457.457 0 01.471-.327.429.429 0 01.4.47l-.41 4.19-.017.085a.456.456 0 01-.592.295l-3.961-1.47-.072-.035a.428.428 0 01-.176-.53l.036-.071a.457.457 0 01.542-.186l2.749 1.02c-1.125-2.23-3.474-3.706-6.114-3.706-3.103 0-5.79 2.038-6.578 4.915a.447.447 0 01-.468.322l-.08-.013zm14.246 2.808l-.08-.013a.447.447 0 00-.468.322c-.787 2.877-3.475 4.915-6.579 4.915-2.64 0-4.988-1.475-6.113-3.705l2.748 1.02a.457.457 0 00.542-.187l.037-.071a.428.428 0 00-.177-.53l-.071-.034L3 11.65a.456.456 0 00-.592.294l-.017.084-.41 4.192a.429.429 0 00.4.47.457.457 0 00.47-.328l.016-.078.279-2.848c1.297 2.45 3.914 4.063 6.85 4.063 3.511 0 6.552-2.307 7.443-5.563a.435.435 0 00-.317-.533z"
            fill="currentColor"
        />
    </svg>
);

export default SvgIcnLoading;
